<template>
  <div id="nova">
    <MainHeader :force-mobile-menu="forceMobileMenu" />

    <!-- Content -->
    <div dusk="content">
      <div
        v-if="!forceMobileMenu"
        class="hidden lg:block lg:absolute left-0 bottom-0 lg:top-[56px] lg:bottom-auto w-60 px-3 py-8"
      >
        <!-- The Main Menu on desktop gets extra padding to keep the bottom of the sidebar from feeling crowded -->
        <MainMenu
          class="pb-24"
          data-screen="desktop"
        />
      </div>

      <div 
        id="content"
        :class="[
          'p-4 md:py-8 md:px-12 space-y-8',
          {'lg:ml-60': !forceMobileMenu}
        ]"
      >
        <Breadcrumbs v-if="breadcrumbsEnabled" />

        <FadeTransition>
          <slot />
        </FadeTransition>

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '@/layouts/MainHeader'
import Footer from '@/layouts/Footer'

export default {
  components: {
    MainHeader,
    Footer,
  },

  data() {
    return {
      forceMobileMenu: false,
    }
  },

  computed: {
    breadcrumbsEnabled() {
      return Nova.config('breadcrumbsEnabled')
    },
  },

  mounted() {
    Nova.$on('error', this.handleError)
    Nova.$on('token-expired', this.handleTokenExpired)
    
    this.forceMobileMenu = window.location.pathname.startsWith('/scenario-maker')

    this.$inertia.on('success', (event) => {

      const pathname = event.target.location.pathname

      this.forceMobileMenu = pathname.startsWith('/scenario-maker')
    })
  },

  beforeUnmount() {
    Nova.$off('error', this.handleError)
    Nova.$off('token-expired', this.handleTokenExpired)
  },

  methods: {
    handleError(message) {
      Nova.error(message)
    },

    handleTokenExpired() {
      // @TODO require Nova._createToast() to support action with link.
      Nova.$toasted.show(this.__('Sorry, your session has expired.'), {
        action: {
          onClick: () => Nova.redirectToLogin(),
          text: this.__('Reload'),
        },
        duration: null,
        type: 'error',
      })

      setTimeout(() => {
        Nova.redirectToLogin()
      }, 5000)
    },
  },
}
</script>
